/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  userReviews: [],
  userReviewsAssignedByMe: [],
  userReviewsLoading: false,
  userReviewsAssignedByMeLoading: false,
  serverError: '',
  submitting: false,
};

export const actions = {
  async fetchReviewsForCurrentUser({ commit }) {
    commit('SET_USER_REVIEWS_LOADING', true);
    await api.get('Review/MyOpenReviews')
      .then((response) => {
        commit('SET_USER_REVIEWS', response.data);
        commit('SET_USER_REVIEWS_LOADING', false);
      })
      .catch(() => {
        commit('SET_USER_REVIEWS_LOADING', false);
      });
  },
  async fetchReviewsAssignedBy({ commit }) {
    commit('SET_USER_REVIEWSBYME_LOADING', true);
    await api.get('Review/ReviewsAssignedByMe')
      .then((response) => {
        commit('SET_USER_REVIEWSBYME', response.data);
        commit('SET_USER_REVIEWSBYME_LOADING', false);
      })
      .catch(() => {
        commit('SET_USER_REVIEWSBYME_LOADING', false);
      });
  },
};

export const mutations = {
  SET_USER_REVIEWS_LOADING(state, loading) {
    state.userReviewsLoading = loading;
  },

  SET_USER_REVIEWS(state, reviews) {
    state.userReviews = reviews;
  },
  SET_USER_REVIEWSBYME_LOADING(state, loading) {
    state.userReviewsAssignedByMeLoading = loading;
  },

  SET_USER_REVIEWSBYME(state, reviews) {
    state.userReviewsAssignedByMe = reviews;
  },
};

export const getters = {
  getReview: state => (id) => {
    if (id) return state.reviews.find(a => a.id === Number(id));
    return null;
  },
};
